module.exports = function view (state, actions) {
  return h('span', {}, state.code ? h('span', { class: 'flag flag-' + (state.code.toLowerCase()), alt: (state.code) }) : undefined)
}
